import React from "react";
import { injectIntl } from "react-intl";
import { Typography, Stack } from "@mui/material";
import { inject, observer } from "mobx-react";
import { PokoroListCard } from "../Styled/HomeStyled";
import PokoroListSlide from "./PokoroListSlide";
import { c } from '../../../theme/colorUtils';

const DeviceSelector = ({ intl, authStore, userStore, modalStore }) => {
  // 기기 이름 표시 함수 (PokoroListDrawer에서 가져온 로직)
  const getDeviceDisplayName = (deviceName) => {
    return deviceName || 'Unknown Device';
  };

  const handleDeviceSelect = (device) => {
    // 디바이스 선택 로직 (userStore 업데이트)
    console.log('Device selected:', device);
  };

  const handleAddDevice = () => {
    // 새 기기 등록 로직
    console.log('Add new device');
  };

  return (
    <>
      <PokoroListCard>
        <Stack gap={0.5}>
          <Typography variant="h6" fontWeight={700}>
            {intl.formatMessage({ id: "connection_list" })} {/* 포코로 목록 */}
          </Typography>
          <Typography variant="body1" color={c.text02}>
            {intl.formatMessage({ id: "connection_list_desc" })} {/* 선택한 기기의 사용현황과 리포트를 보여줍니다. */}
          </Typography>
        </Stack>
      </PokoroListCard>
      <PokoroListSlide
        getDeviceDisplayName={getDeviceDisplayName}
        onDeviceSelect={handleDeviceSelect}
        onAddDevice={handleAddDevice}
      />
    </>
  );
};

export default injectIntl(
  inject("authStore", "userStore", "modalStore")(observer(DeviceSelector))
);
